import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { createContext, useContext, useEffect, useState } from "react";
import { Backend } from "../backend";

const AuthContext = createContext(null);

export function AuthProvider({children}){
    const [user, setUser] = useState(null);
    const [roles, setRoles] = useState({ isProvider: false, isAdmin: false, providerId: "" });
    const [loading, setLoading] = useState(true);
    const auth = getAuth();

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async(currentUser) => {
            setUser(currentUser);
            if(currentUser){
                try {
                    const result = await Backend.userService.getUserRoles();
                    setRoles({
                        isProvider: result.isProvider,
                        isAdmin: result.isAdmin,
                        providerId: result.isProvider ? currentUser.uid : ""
                    });
                } catch (error) {
                    console.error("Error fetching user roles:", error);
                    setRoles({ isProvider: false, isAdmin: false, providerId: "" });
                }
            }
            else{
                setRoles({ isProvider: false, isAdmin: false, providerId: "" });
            }
            setLoading(false);
        });
        return () => unsubscribe();
    }, []);

    const logout = async () => {
        try {
            await signOut(auth);
        } catch (error) {
            console.error('Error signing out:', error);
            throw error;
        }
    };

    return(
        <AuthContext.Provider value ={{user, roles, loading, logout}}>
            {children}
        </AuthContext.Provider>
    );

}

export const useAuth = () => useContext(AuthContext);
